var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      directives: [
        {
          name: "tooltip",
          rawName: "v-tooltip",
          value: {
            content: _vm.tooltipContent,
            html: true,
            triggers: ["click"],
            autoHide: true,
            delay: {
              show: 0,
              hide: 0,
            },
          },
          expression:
            "{\n    content: tooltipContent,\n    html: true,\n    triggers: ['click'],\n    autoHide: true,\n    delay: {\n      show: 0,\n      hide: 0,\n    },\n  }",
        },
      ],
      staticClass: "c-outage-tooltip",
    },
    [_c("span", { staticClass: "c-outage-tooltip__inner" }, [_vm._v("?")])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }